// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l37sN","label":"styles_label__3tcZB"};